/**
 * Set of key codes.
 * `POINTER` is a ReactGrid addon
 *
 * @enum {number}
 */
export let keyCodes;
(function (keyCodes) {
  keyCodes[(keyCodes['POINTER'] = 1)] = 'POINTER';
  keyCodes[(keyCodes['BACKSPACE'] = 8)] = 'BACKSPACE';
  keyCodes[(keyCodes['TAB'] = 9)] = 'TAB';
  keyCodes[(keyCodes['ENTER'] = 13)] = 'ENTER';
  keyCodes[(keyCodes['SHIFT'] = 16)] = 'SHIFT';
  keyCodes[(keyCodes['CTRL'] = 17)] = 'CTRL';
  keyCodes[(keyCodes['ALT'] = 18)] = 'ALT';
  keyCodes[(keyCodes['PAUSE'] = 19)] = 'PAUSE';
  keyCodes[(keyCodes['CAPS_LOCK'] = 20)] = 'CAPS_LOCK';
  keyCodes[(keyCodes['ESCAPE'] = 27)] = 'ESCAPE';
  keyCodes[(keyCodes['SPACE'] = 32)] = 'SPACE';
  keyCodes[(keyCodes['PAGE_UP'] = 33)] = 'PAGE_UP';
  keyCodes[(keyCodes['PAGE_DOWN'] = 34)] = 'PAGE_DOWN';
  keyCodes[(keyCodes['END'] = 35)] = 'END';
  keyCodes[(keyCodes['HOME'] = 36)] = 'HOME';
  keyCodes[(keyCodes['LEFT_ARROW'] = 37)] = 'LEFT_ARROW';
  keyCodes[(keyCodes['UP_ARROW'] = 38)] = 'UP_ARROW';
  keyCodes[(keyCodes['RIGHT_ARROW'] = 39)] = 'RIGHT_ARROW';
  keyCodes[(keyCodes['DOWN_ARROW'] = 40)] = 'DOWN_ARROW';
  keyCodes[(keyCodes['INSERT'] = 45)] = 'INSERT';
  keyCodes[(keyCodes['DELETE'] = 46)] = 'DELETE';
  keyCodes[(keyCodes['KEY_0'] = 48)] = 'KEY_0';
  keyCodes[(keyCodes['KEY_1'] = 49)] = 'KEY_1';
  keyCodes[(keyCodes['KEY_2'] = 50)] = 'KEY_2';
  keyCodes[(keyCodes['KEY_3'] = 51)] = 'KEY_3';
  keyCodes[(keyCodes['KEY_4'] = 52)] = 'KEY_4';
  keyCodes[(keyCodes['KEY_5'] = 53)] = 'KEY_5';
  keyCodes[(keyCodes['KEY_6'] = 54)] = 'KEY_6';
  keyCodes[(keyCodes['KEY_7'] = 55)] = 'KEY_7';
  keyCodes[(keyCodes['KEY_8'] = 56)] = 'KEY_8';
  keyCodes[(keyCodes['KEY_9'] = 57)] = 'KEY_9';
  keyCodes[(keyCodes['KEY_A'] = 65)] = 'KEY_A';
  keyCodes[(keyCodes['KEY_B'] = 66)] = 'KEY_B';
  keyCodes[(keyCodes['KEY_C'] = 67)] = 'KEY_C';
  keyCodes[(keyCodes['KEY_D'] = 68)] = 'KEY_D';
  keyCodes[(keyCodes['KEY_E'] = 69)] = 'KEY_E';
  keyCodes[(keyCodes['KEY_F'] = 70)] = 'KEY_F';
  keyCodes[(keyCodes['KEY_G'] = 71)] = 'KEY_G';
  keyCodes[(keyCodes['KEY_H'] = 72)] = 'KEY_H';
  keyCodes[(keyCodes['KEY_I'] = 73)] = 'KEY_I';
  keyCodes[(keyCodes['KEY_J'] = 74)] = 'KEY_J';
  keyCodes[(keyCodes['KEY_K'] = 75)] = 'KEY_K';
  keyCodes[(keyCodes['KEY_L'] = 76)] = 'KEY_L';
  keyCodes[(keyCodes['KEY_M'] = 77)] = 'KEY_M';
  keyCodes[(keyCodes['KEY_N'] = 78)] = 'KEY_N';
  keyCodes[(keyCodes['KEY_O'] = 79)] = 'KEY_O';
  keyCodes[(keyCodes['KEY_P'] = 80)] = 'KEY_P';
  keyCodes[(keyCodes['KEY_Q'] = 81)] = 'KEY_Q';
  keyCodes[(keyCodes['KEY_R'] = 82)] = 'KEY_R';
  keyCodes[(keyCodes['KEY_S'] = 83)] = 'KEY_S';
  keyCodes[(keyCodes['KEY_T'] = 84)] = 'KEY_T';
  keyCodes[(keyCodes['KEY_U'] = 85)] = 'KEY_U';
  keyCodes[(keyCodes['KEY_V'] = 86)] = 'KEY_V';
  keyCodes[(keyCodes['KEY_W'] = 87)] = 'KEY_W';
  keyCodes[(keyCodes['KEY_X'] = 88)] = 'KEY_X';
  keyCodes[(keyCodes['KEY_Y'] = 89)] = 'KEY_Y';
  keyCodes[(keyCodes['KEY_Z'] = 90)] = 'KEY_Z';
  keyCodes[(keyCodes['LEFT_META'] = 91)] = 'LEFT_META';
  keyCodes[(keyCodes['RIGHT_META'] = 92)] = 'RIGHT_META';
  keyCodes[(keyCodes['SELECT'] = 93)] = 'SELECT';
  keyCodes[(keyCodes['NUMPAD_0'] = 96)] = 'NUMPAD_0';
  keyCodes[(keyCodes['NUMPAD_1'] = 97)] = 'NUMPAD_1';
  keyCodes[(keyCodes['NUMPAD_2'] = 98)] = 'NUMPAD_2';
  keyCodes[(keyCodes['NUMPAD_3'] = 99)] = 'NUMPAD_3';
  keyCodes[(keyCodes['NUMPAD_4'] = 100)] = 'NUMPAD_4';
  keyCodes[(keyCodes['NUMPAD_5'] = 101)] = 'NUMPAD_5';
  keyCodes[(keyCodes['NUMPAD_6'] = 102)] = 'NUMPAD_6';
  keyCodes[(keyCodes['NUMPAD_7'] = 103)] = 'NUMPAD_7';
  keyCodes[(keyCodes['NUMPAD_8'] = 104)] = 'NUMPAD_8';
  keyCodes[(keyCodes['NUMPAD_9'] = 105)] = 'NUMPAD_9';
  keyCodes[(keyCodes['MULTIPLY'] = 106)] = 'MULTIPLY';
  keyCodes[(keyCodes['ADD'] = 107)] = 'ADD';
  keyCodes[(keyCodes['SUBTRACT'] = 109)] = 'SUBTRACT';
  keyCodes[(keyCodes['DECIMAL'] = 110)] = 'DECIMAL';
  keyCodes[(keyCodes['DIVIDE'] = 111)] = 'DIVIDE';
  keyCodes[(keyCodes['F1'] = 112)] = 'F1';
  keyCodes[(keyCodes['F2'] = 113)] = 'F2';
  keyCodes[(keyCodes['F3'] = 114)] = 'F3';
  keyCodes[(keyCodes['F4'] = 115)] = 'F4';
  keyCodes[(keyCodes['F5'] = 116)] = 'F5';
  keyCodes[(keyCodes['F6'] = 117)] = 'F6';
  keyCodes[(keyCodes['F7'] = 118)] = 'F7';
  keyCodes[(keyCodes['F8'] = 119)] = 'F8';
  keyCodes[(keyCodes['F9'] = 120)] = 'F9';
  keyCodes[(keyCodes['F10'] = 121)] = 'F10';
  keyCodes[(keyCodes['F11'] = 122)] = 'F11';
  keyCodes[(keyCodes['F12'] = 123)] = 'F12';
  keyCodes[(keyCodes['NUM_LOCK'] = 144)] = 'NUM_LOCK';
  keyCodes[(keyCodes['SCROLL_LOCK'] = 145)] = 'SCROLL_LOCK';
  keyCodes[(keyCodes['FIREFOX_DASH'] = 173)] = 'FIREFOX_DASH';
  keyCodes[(keyCodes['SEMICOLON'] = 186)] = 'SEMICOLON';
  keyCodes[(keyCodes['EQUALS'] = 187)] = 'EQUALS';
  keyCodes[(keyCodes['COMMA'] = 188)] = 'COMMA';
  keyCodes[(keyCodes['DASH'] = 189)] = 'DASH';
  keyCodes[(keyCodes['PERIOD'] = 190)] = 'PERIOD';
  keyCodes[(keyCodes['FORWARD_SLASH'] = 191)] = 'FORWARD_SLASH';
  keyCodes[(keyCodes['GRAVE_ACCENT'] = 192)] = 'GRAVE_ACCENT';
  keyCodes[(keyCodes['OPEN_BRACKET'] = 219)] = 'OPEN_BRACKET';
  keyCodes[(keyCodes['BACK_SLASH'] = 220)] = 'BACK_SLASH';
  keyCodes[(keyCodes['CLOSE_BRACKET'] = 221)] = 'CLOSE_BRACKET';
  keyCodes[(keyCodes['SINGLE_QUOTE'] = 222)] = 'SINGLE_QUOTE';
})(keyCodes || (keyCodes = {}));
